module.exports = __webpack_public_path__ + "static/media/copyClipboard.148fba31.svg";